import { render, staticRenderFns } from "./ReporteLuminariaPorPotenciaChart.vue?vue&type=template&id=292fc62d"
import script from "./ReporteLuminariaPorPotenciaChart.vue?vue&type=script&lang=js"
export * from "./ReporteLuminariaPorPotenciaChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports